import { AxiosPromise } from 'axios';
import request from '@/utils/request';

import type {
  HomePageCategoryVo,
  GameServicePopularSearchVo,
  GameServicePopularSearchingVo,
  HomePageSearchVo,
  HomePageSearchVos,
  HomeBnaner
} from './types.ts';

export const getHomePageCategoryVo = (): AxiosPromise<HomePageCategoryVo[]> => {
  return request({
    url: '/product/urlMapping/game-service/getHomePageCategoryVo',
    method: 'get'
  });
};
// banner
export const getBannerInfo = (): AxiosPromise<HomeBnaner[]> => {
  return request({
    url: '/product/api/banner/info',
    method: 'get'
  });
};

// 主站首页激活搜索
export const getHomePageActiveSearch = (): AxiosPromise<GameServicePopularSearchVo[]> => {
  return request({
    url: '/product/urlMapping/game-service/homePageActiveSearch',
    method: 'get'
  });
};

// 主站首页激活搜索 新
export const getHomePageActiveSearching = (): AxiosPromise<GameServicePopularSearchingVo> => {
  return request({
    url: '/product/urlMapping/game-service/homePageActiveSearching',
    method: 'get'
  });
};

// 主站首页查询
export const getHomePageSearch = (searchWord: string): AxiosPromise<HomePageSearchVo> => {
  return request({
    url: '/product/urlMapping/game-service/homePageSearch',
    method: 'get',
    params: { searchWord }
  });
};

// 主站首页查询 新
export const getHomePageSearching = (searchWord: string): AxiosPromise<HomePageSearchVos> => {
  return request({
    url: '/product/urlMapping/game-service/homePageSearching',
    method: 'get',
    params: { searchWord }
  });
};

// 主站首页查询，根据输入的搜索词查询数据后，点击view all 显示全部数据
export const homePageSearchViewAll = (params: { searchWord: string; limit: number }): AxiosPromise<HomePageSearchVo> => {
  return request({
    url: '/product/urlMapping/game-service/homePageSearchViewAll',
    method: 'get',
    params
  });
};
